import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  withRouter,
} from 'react-router-dom';

import {
  Formatters,
  ExtendedFlex,
  ScrollToTopOnMount,
} from '../../../coreui';

import CompletedInvestmentsTable from '../../components/CompletedInvestmentsTable';
import SummaryItem from '../../components/SummaryItem';

class CompletedInvestmentsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <ExtendedFlex
        flexDirection="column"
        width="100%"
        alignItems="center"
      >
        <ScrollToTopOnMount />
        { this.props.data.totalInvested &&
          <ExtendedFlex
            flexDirection="column"
            width={1}
            minWidth={280}
            maxWidth={['75%', 1540]}
            px={[0, 50]}
            pb={[40, 50]}
          >
            <ExtendedFlex
              w={1}
              py={[0, 30, 50]}
              flexDirection={['column', 'row']}
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <SummaryItem
                value={this.props.data.totalInvested.value}
                label="TOTAL INVESTED-COMPLETED"
                dataType="D8"
                valueFormat={Formatters.DOLLARS_DECIMALS}
                tooltipText={this.props.data.totalInvested.tooltip}
              />
              <SummaryItem
                value={this.props.data.totalReturned.value}
                label="TOTAL RETURNED-COMPLETED"
                dataType="D8"
                valueFormat={Formatters.DOLLARS_DECIMALS}
                tooltipText={this.props.data.totalReturned.tooltip}
              />
            </ExtendedFlex>
          </ExtendedFlex> }
        {
          this.props.data.privatePlacementData !== undefined &&
          <CompletedInvestmentsTable
            investments={this.props.data.privatePlacementData.ios}
          />
        }
      </ExtendedFlex>
    );
  }
}

CompletedInvestmentsContainer.propTypes = {
  data: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    data: state.dashboard.data.completedInvestmentsData,
  };
};

export default withRouter(
  connect(mapStateToProps)(CompletedInvestmentsContainer),
);
